<template>
  <nav class="max-w-[271px] md:max-w-full">
    <ul class="flex flex-col gap-[27px] md:flex-row md:w-full md:gap-[64px] xl:gap-[100px]">
      <!-- Chapter item -->
      <FooterNavChapterItem v-for="chapter in navList" :key="chapter.title" :chapter="chapter" />
    </ul>
  </nav>
</template>

<script setup>
import navList from "static/footer-nav.ts"
import FooterNavChapterItem from "./FooterNavChapterItem.vue"
</script>

<style lang="scss" scoped>
.active {
  @apply flex;
}
</style>
